import { doNothing } from "@edgetier/utilities";
import { TimePeriodGroupBy } from "@edgetier/watchtower-types";
import { createContext } from "react";
import { IPhraseTriggerContext } from "./phrase-trigger-context.types";
import { endOfToday, startOfToday, subDays } from "date-fns";
import { INTERACTIONS_TAGGED_DATE_RANGE } from "constants/phrase-triggers";

export const defaultContext: IPhraseTriggerContext = {
    filters: {
        dayTriggerView: false,
        groupBy: TimePeriodGroupBy.Days,
        startDateTime: subDays(startOfToday(), INTERACTIONS_TAGGED_DATE_RANGE),
        endDateTime: endOfToday(),
    },
    setFilters: doNothing,
};

export const PhraseTriggerContext = createContext(defaultContext);
